// Table of contents:
// 1 orderResponse
// 2 despatchAdvice
// 3 invoice
import { Orders } from '../../../data'
import { getTranslationsForConfig } from '../getTranslationsForConfig'

export const createOrders = (): Orders => {
  return {
    // 1 orderResponse
    orderResponse: {
      enabled: true,
      table: {
        enabled: true,
        columns: [
          {
            // Bestellnummer
            dataType: 'string',
            field: 'Payload.OrderId',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'orders.orderResponse.table.columns.orderId.filterPlaceholder',
            ), // i18n.t('orders.orderResponse.table.columns.orderId.filterPlaceholder')
            header: getTranslationsForConfig(
              'orders.orderResponse.table.columns.orderId.header',
            ), // t('orders.orderResponse.table.columns.orderId.header')
            sortable: true,
          },
          {
            // Bestelldatum
            align: 'right',
            dataType: 'date',
            field: 'Payload.OrderDate',
            filter: true,
            header: getTranslationsForConfig(
              'orders.orderResponse.table.columns.orderDate.header',
            ), // i18n.t('orders.orderResponse.table.columns.orderDate.header')
            sortable: true,
          },
          {
            // Lieferdatum Käufer
            align: 'right',
            dataType: 'date',
            field: 'Payload.OrderDeliveryDate',
            filter: true,
            header: getTranslationsForConfig(
              'orders.orderResponse.table.columns.orderDeliveryDate.header',
            ), // i18n.t('orders.orderResponse.table.columns.orderDeliveryDate.header')
            sortable: true,
          },
          {
            // Gesamtbetrag
            align: 'right',
            dataType: 'price',
            field: 'Payload.InvoiceAmount',
            filter: true,
            header: getTranslationsForConfig(
              'orders.orderResponse.table.columns.invoiceAmount.header',
            ), // i18n.t('orders.orderResponse.table.columns.invoiceAmount.header')
            sortable: true,
          },
          {
            // Währung
            dataType: 'currency',
            field: 'Payload.Currency',
            filter: true,
            header: getTranslationsForConfig(
              'orders.orderResponse.table.columns.currency.header',
            ), // i18n.t('orders.orderResponse.table.columns.currency.header')
            sortable: true,
          },
          {
            // Status
            alignFrozen: 'right',
            dataType: 'status',
            field: 'Payload.ConfirmationCode',
            filter: true,
            frozen: true,
            header: getTranslationsForConfig(
              'orders.orderResponse.table.columns.status.header',
            ), // i18n.t('orders.orderResponse.table.columns.status.header')
            sortable: true,
          },
        ],
        emptyMessageDetails: getTranslationsForConfig(
          'orders.orderResponse.table.emptyMessageDetails',
        ), // t("orders.orderResponse.table.emptyMessageDetails")
        emptyMessageTitle: getTranslationsForConfig(
          'orders.orderResponse.table.emptyMessageTitle',
        ), // t("orders.orderResponse.table.emptyMessageTitle")
        paginator: true,
        rows: 5,
        rowsPerPageOptions: [5, 20, 50],
        sortField: 'Payload.OrderDate',
        sortOrder: 1,
      },
    },
    // 2 despatchAdvice
    despatchAdvice: {
      enabled: true,
      table: {
        enabled: true,
        columns: [
          {
            // Bestellnummer
            dataType: 'string',
            field: 'Payload.OrderId',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'orders.despatchAdvice.table.columns.orderId.filterPlaceholder',
            ), // i18n.t('orders.despatchAdvice.table.columns.orderId.filterPlaceholder')
            header: getTranslationsForConfig(
              'orders.despatchAdvice.table.columns.orderId.header',
            ), // i18n.t('orders.despatchAdvice.table.columns.orderId.header')
            sortable: true,
          },
          {
            // Bestelldatum
            align: 'right',
            dataType: 'date',
            field: 'Payload.OrderDate',
            filter: true,
            header: getTranslationsForConfig(
              'orders.despatchAdvice.table.columns.orderDate.header',
            ), // i18n.t('orders.despatchAdvice.table.columns.orderDate.header')
            sortable: true,
          },
          {
            // Auftragsbestätigungsnummer
            dataType: 'string',
            field: 'Payload.ConfirmationId',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'orders.despatchAdvice.table.columns.confirmationId.filterPlaceholder',
            ), // i18n.t('orders.despatchAdvice.table.columns.confirmationId.filterPlaceholder')
            header: getTranslationsForConfig(
              'orders.despatchAdvice.table.columns.confirmationId.header',
            ), // i18n.t('orders.despatchAdvice.table.columns.confirmationDate.header')
            sortable: true,
          },
          {
            // Auftragsbestätigungsdatum
            align: 'right',
            dataType: 'date',
            field: 'Payload.ConfirmationDate',
            filter: true,
            header: getTranslationsForConfig(
              'orders.despatchAdvice.table.columns.confirmationDate.header',
            ), // i18n.t('orders.despatchAdvice.table.columns.confirmationDate.header')
            sortable: true,
          },
          {
            // Lieferart
            dataType: 'deliveryType',
            field: 'Payload.DeliveryType',
            filter: true,
            header: getTranslationsForConfig(
              'orders.despatchAdvice.table.columns.deliveryType.header',
            ), // i18n.t('orders.despatchAdvice.table.columns.deliveryType.header')
            sortable: true,
          },
          {
            // Lieferdatum
            align: 'right',
            dataType: 'date',
            field: 'Payload.DeliveryDate',
            filter: true,
            header: getTranslationsForConfig(
              'orders.despatchAdvice.table.columns.deliveryDate.header',
            ), // i18n.t('orders.despatchAdvice.table.columns.deliveryDate.header')
            sortable: true,
          },
          {
            // Status
            alignFrozen: 'right',
            dataType: 'status',
            field: 'Payload.ConfirmationCode',
            filter: true,
            frozen: true,
            header: getTranslationsForConfig(
              'orders.despatchAdvice.table.columns.confirmationCode.header',
            ), // i18n.t('orders.despatchAdvice.table.columns.confirmationCode.header')
            sortable: true,
          },
        ],
        emptyMessageDetails: getTranslationsForConfig(
          'orders.despatchAdvice.table.emptyMessageDetails',
        ), // i18n.t('orders.despatchAdvice.table.emptyMessageDetails')
        emptyMessageTitle: getTranslationsForConfig(
          'orders.despatchAdvice.table.emptyMessageTitle',
        ), // i18n.t('orders.despatchAdvice.table.emptyMessageTitle')
        paginator: true,
        rows: 5,
        rowsPerPageOptions: [5, 20, 50],
        sortField: 'Payload.OrderDate',
        sortOrder: 1,
      },
    },
    // 3 invoice
    invoice: {
      enabled: true,
      table: {
        enabled: true,
        columns: [
          {
            // Bestellnummer
            dataType: 'string',
            field: 'Payload.OrderId',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'orders.invoice.table.columns.orderId.filterPlaceholder',
            ), // i18n.t('orders.invoice.table.columns.orderId.filterPlaceholder')
            header: getTranslationsForConfig(
              'orders.invoice.table.columns.orderId.header',
            ), // i18n.t('orders.invoice.table.columns.orderId.header')
            sortable: true,
          },
          {
            // Bestelldatum
            align: 'right',
            dataType: 'date',
            field: 'Payload.OrderDate',
            filter: true,
            header: getTranslationsForConfig(
              'orders.invoice.table.columns.orderDate.header',
            ), // i18n.t('orders.invoice.table.columns.orderDate.header')
            sortable: true,
          },
          {
            // Auftragsbestätigungsnummer
            dataType: 'string',
            field: 'Payload.ConfirmationId',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'orders.invoice.table.columns.confirmationId.filterPlaceholder',
            ), // i18n.t('orders.invoice.table.columns.confirmationId.filterPlaceholder')
            header: getTranslationsForConfig(
              'orders.invoice.table.columns.confirmationId.header',
            ), // i18n.t('orders.invoice.table.columns.confirmationId.header')
            sortable: true,
          },
          {
            // Auftragsbestätigungsdatum
            align: 'right',
            dataType: 'date',
            field: 'Payload.ConfirmationDate',
            filter: true,
            header: getTranslationsForConfig(
              'orders.invoice.table.columns.confirmationDate.header',
            ), // i18n.t('orders.invoice.table.columns.confirmationDate.header')
            sortable: true,
          },
          {
            // Lieferscheinnummer
            dataType: 'string',
            field: 'Payload.DeliveryNoteNumber',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'orders.invoice.table.columns.deliveryNoteNumber.filterPlaceholder',
            ), // i18n.t('orders.invoice.table.columns.deliveryNoteNumber.filterPlaceholder')
            header: getTranslationsForConfig(
              'orders.invoice.table.columns.deliveryNoteNumber.header',
            ), // i18n.t('orders.invoice.table.columns.deliveryNoteNumber.header')
            sortable: true,
          },
          {
            // Lieferscheindatum
            align: 'right',
            dataType: 'date',
            field: 'Payload.DeliveryNoteDate',
            filter: true,
            header: getTranslationsForConfig(
              'orders.invoice.table.columns.deliveryNoteDate.header',
            ), // i18n.t('orders.invoice.table.columns.deliveryNoteDate.header')
            sortable: true,
          },
          {
            // Rechnungsart
            dataType: 'deliveryType',
            field: 'Payload.DeliveryType',
            filter: true,
            header: getTranslationsForConfig(
              'orders.invoice.table.columns.deliveryType.header',
            ), // i18n.t('orders.invoice.table.columns.deliveryType.header')
            sortable: true,
          },
          {
            // Status
            alignFrozen: 'right',
            dataType: 'status',
            field: 'Payload.ConfirmationCode',
            filter: true,
            frozen: true,
            header: getTranslationsForConfig(
              'orders.invoice.table.columns.confirmationCode.header',
            ), // i18n.t('orders.invoice.table.columns.confirmationCode.header')
            sortable: true,
          },
        ],
        emptyMessageDetails: getTranslationsForConfig(
          'orders.invoice.table.emptyMessageDetails',
        ), // i18n.t('orders.invoice.table.emptyMessageDetails')
        emptyMessageTitle: getTranslationsForConfig(
          'orders.invoice.table.emptyMessageTitle',
        ), // i18n.t('orders.invoice.table.emptyMessageTitle')
        paginator: true,
        rows: 5,
        rowsPerPageOptions: [5, 20, 50],
        sortField: 'Payload.OrderDate',
        sortOrder: 1,
      },
    },
  }
}
